<template>
  <section id="readytemplatesselector" :class="$conf.sidebar.enabled ? '' : 'on-edge'">
    <button
      :disabled="this.$store.getters['isUiDisabled']"
      class="button is-dark has-background-black-bis qgs-b"
      type="button"
      @click="downloadQgs">
        {{ $t('help.qgis.download') }}
        <b-icon id="downloadicon" icon="file-download"></b-icon>
    </button>
  </section>
</template>

<script>

import log from 'util/log'
import { deepCopy, getRasterDatesFromApi, getRasterDatesFromWms, fillUniversalQGISTemplate } from 'util/helpers'

import main from '../../qgis_templates/main.template.xml'
import custom_order_item from '../../qgis_templates/components/custom_order_item.template.xml'
import layer_tree_group_layer_tree_layer from '../../qgis_templates/components/layer_tree_group_layer_tree_layer.template.xml'
import layerorder_layer from '../../qgis_templates/components/layerorder_layer.template.xml'
import legend_legendlayer from '../../qgis_templates/components/legend_legendlayer.template.xml'
import mapcanvas_extent from '../../qgis_templates/components/mapcanvas_extent.template.xml'
import projectlayers_maplayer from '../../qgis_templates/components/projectlayers_maplayer.template.xml'
import source from '../../qgis_templates/components/source.template.xml'

export default {
  data () {
    return {
      xmlComponents: {
        main,
        custom_order_item,
        layer_tree_group_layer_tree_layer,
        layerorder_layer,
        legend_legendlayer,
        mapcanvas_extent,
        projectlayers_maplayer,
        source
      },
      mapLayersToSave: []
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    downloadQgs: async function () {
      let activeLayer = this.$store.getters['baseLayer']
      let activeTime = this.$store.getters['mapTime']
      let baseLayers = deepCopy(this.$conf.map.layers.baseLayers)
      let fileName = this.$store.getters['config'].name
      let rasterTypePresenceOnDate = {}

      for (const layer in baseLayers) {
        const layerType = baseLayers[layer].layerType
        // Remove empty layer
        if (layerType === 'clear') {
          delete baseLayers[layer]
          continue
        }

        // Set activity flag
        baseLayers[layer].checked = baseLayers[layer].id === activeLayer ? true : false

        // Create an object with flags that indicate if raster(by type) is present on a given date, remove if necessary
        if (!(rasterTypePresenceOnDate.hasOwnProperty(layerType))) {
          // Use wait here to make the requests one by one and wait for them
          rasterTypePresenceOnDate[layerType] = await getRasterDatesFromWms(this.$store.getters['config'], layer).then(dates => {
            let datesIncludes = activeTime.every(time => {
              return dates.includes(time)
            })
            if (datesIncludes){
              return true
            }
            else {
              delete baseLayers[layer]
              return false
            }
          })
        } 
        else {
          if (rasterTypePresenceOnDate[layerType] === false) {
            delete baseLayers[layer]
          }
        }
      }

      fileName = fileName.replaceAll(' ','_')
      fillUniversalQGISTemplate(activeTime, this.$map.getFit().bbox, this.xmlComponents, fileName, baseLayers)
    }
  }
}

</script>

<style lang="stylus">

section#readytemplatesselector
  position: fixed
  white-space: nowrap
  left: 10px
  top: 10px
  transition: 0.35s
  font-size: 0
  z-index: 1004
  >.qgs-b
    >.icon
      margin-left: 5px

@media (min-width: 768px)
  section#readytemplatesselector
    position: absolute
    left: 385px
    top: 10px
    width: auto
    &.on-edge
      left: 360px

</style>
